import { createUseStyles } from '../../theme/theming';

export const importSlickStyles = createUseStyles({
  '@import': [
    'url(https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css)',
    'url(https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css)'
  ],
  '@global': {
    '.slick-track': {
      display: 'flex !important'
    },
    '.slick-slide': {
      height: 'inherit !important',
      '&>div': {
        height: '100%'
      }
    }
  }
});

const useCarouselStyles = createUseStyles((theme) => ({
  sliderClass: {
    '& .slick-dots': {
      bottom: ({ buttonContainerClass } = {}) =>
        !!buttonContainerClass ? '10px' : 'unset',
      position: ({ buttonContainerClass } = {}) =>
        !!buttonContainerClass ? 'absolute' : 'inherit',
      width: '100%',
      margin: '0',
      listStyle: 'none',
      textAlign: 'center',
      paddingBottom: '0',
      '& ul': {
        margin: theme.spacing.margin.regular,
        padding: '0',

        '& li': {
          width: 'unset',
          height: 'unset',
          margin: '0'
        }
      }
    }
  },
  swipeClass: {
    position: 'absolute !important',
    bottom: '100px !important'
  },
  sliderButtonContainer: {
    display: 'flex',
    gap: '20px',
    justifyContent: 'center',
    marginTop: '20px'
  },

  buttonContainer: {
    display: 'flex',
    gap: '20px',
    justifyContent: 'center',
    marginTop: theme.spacing.margin.tiny
  },
  dots: {
    width: '4px',
    height: '4px ',
    background: ({ inverted } = {}) =>
      !!inverted
        ? theme?.palette?.font?.invertedDefault
        : theme.palette.primary.light,
    borderRadius: '10px',
    margin: '0 4px'
  },
  activeDot: {
    extend: 'dots',
    width: '26px',
    background: ({ inverted } = {}) =>
      !!inverted
        ? theme?.palette?.font?.invertedDefault
        : theme.colors.AccentColor
  },

  '@media screen and (max-width: 767px)': {
    sliderClass: {
      '& .slick-dots': {
        '& ul': {
          margin: '0px'
        }
      }
    }
  }
}));

export default useCarouselStyles;
